import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { AgentProvider } from './auth/AgentProvider';
import { router } from './app/router';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AgentProvider>
      <RouterProvider router={router} />
    </AgentProvider>
  </StrictMode>,
);
